import ActionButtons from './ActionButtons';
import EventCalendar from './EventCalendar';
import { useTimelineContextValue } from './functions';
import { TimelineContextProvider } from './TimelineContext';
import { usePrefetchFavoriteIcons } from './useFavoriteIcons';
import { useMagicImportLogic } from './useMagicImport';

const DetailsChronologicalMode = () => {
  const value = useTimelineContextValue();
  usePrefetchFavoriteIcons();

  const { status, isLoading, magicImport } = useMagicImportLogic();

  return (
    <TimelineContextProvider value={{ ...value, magicImportLogic: { status, isLoading, magicImport } }}>
      <EventCalendar />
      <ActionButtons />
    </TimelineContextProvider>
  );
};

export default DetailsChronologicalMode;
